<template>
    <div>
        <!-- header -->
        <el-container style="overflow:hidden;">
            <el-header class="layout-header">
                <el-row>
                    <el-col :span="16">
                        <div class="header-logo" @click="logoOnClick">
                            <!-- <i class="iconfont plfonthuanbaolvhua"></i> -->
                            <h1 style="margin-top: 10px;font-size:36px; font-family: 'PangMenChenDao', sans-serif;">全民跳绳赛事管理系统
                                <!-- <span style="font-size: 13px;margin-left: 6px;background-color: white;color: #409eff;padding: 1px 3px;border-radius: 5px;">V1.0</span> -->
                            </h1>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="avatar-div">
                            <el-dropdown placement="bottom-end" trigger="hover">
                                <div class="content-div">
                                    <img :src="headerAvatarUrl" />
                                    <p>{{ username }}</p>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item icon="el-icon-user"
                                        @click.native="toContestantIndex">报名系统</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-edit"
                                        @click.native="editPwdOnclick">修改密码</el-dropdown-item>
                                    <el-dropdown-item :divided="true" icon="el-icon-switch-button"
                                        @click.native="loginoutOnclick()">退出登录</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </el-col>
                </el-row>
            </el-header>

            <!-- content -->
            <el-container style="height:calc(100vh - 120px);">
                <!-- aside -->
                <el-scrollbar class="aside-scrollbar hidden-el-overflow-x">
                    <el-aside style="width:auto;overflow-x:hidden;overflow-y:hidden;">
                        <div class="menu-collapse">
                            <button @click="menuIsCollapse = !menuIsCollapse">
                                <i class="el-icon-s-fold" :class="{ 'ele-transform-180deg': menuIsCollapse }"></i>
                            </button>
                        </div>
                        <el-menu :default-active="activeRoute" mode="vertical" class="el-menu-vertical-demo"
                            :router="true" style="border:none;" :collapse="menuIsCollapse" ref="mainpage-left-menu">
                            <template v-for="menus in enumList">
                                <template v-if="menus.Submenus.length > 0">
                                    <el-submenu :index="menus.MenuId + ''" :key="menus.MenuId">
                                        <template slot="title">
                                            <i v-if="menus.MenuIcon" :class="menus.MenuIcon"></i>
                                            <span slot="title">{{ menus.MenuName }}</span>
                                        </template>
                                        <el-menu-item v-for="childItem in menus.Submenus" :index="childItem.MenuUrl"
                                            :key="childItem.MenuId">
                                            <i v-if="childItem.MenuIcon" :class="childItem.MenuIcon"></i>
                                            <span slot="title">{{ childItem.MenuName }}</span>
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                                <template v-else>
                                    <el-menu-item :index="menus.MenuUrl" :key="menus.MenuId">
                                        <i v-if="menus.MenuIcon" :class="menus.MenuIcon"></i>
                                        <span slot="title">{{ menus.MenuName }}</span>
                                    </el-menu-item>
                                </template>
                            </template>
                        </el-menu>
                    </el-aside>
                </el-scrollbar>

                <!-- main -->
                <el-scrollbar class="main-scrollbar hidden-el-overflow-x" v-if="mainInfoLoaded">
                    <el-main>
                        <router-view></router-view>
                    </el-main>
                </el-scrollbar>
            </el-container>
        </el-container>

        <el-dialog title="修改密码" :visible.sync="editPwdObj.visible" width="30%" @close="editPwdObj.visible = false">
            <el-form :model="editPwdObj.dataForm" v-loading="editPwdObj.loading" label-width="120px" style="width: 80%;margin: 0 auto;">
                <el-form-item label="旧密码">
                    <el-input show-password v-model="editPwdObj.dataForm.oldPwdStr"></el-input>
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input show-password v-model="editPwdObj.dataForm.newPwdStr"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码">
                    <el-input show-password v-model="editPwdObj.dataForm.cNewPwdStr"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="editPwdSubmitOnclick">修 改</el-button>
                    <el-button @click="editPwdObj.visible = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import UtilsCommon from "./../../utils/utils-common.js";
import UserInfoService from "./../../request-server/request-services/userinfo-services.js";
import SystemService from "../../request-server/request-services/system-services.js";
import Axios from "axios";

export default {
    name: "main-layout",
    data() {
        return {
            logo: UtilsCommon.getAssetsFiles("images/logo.jpg"),
            headerAvatarUrl: UtilsCommon.getAssetsFiles("default-header-icon.png"),
            enumList: [],
            username: '',
            editPwdObj: {
                visible: false,
                loading: false,
                dataForm: {
                    oldPwdStr: '',
                    newPwdStr: "",
                    cNewPwdStr: ""
                }
            },
            menuIsCollapse: false,
            activeRoute: "",
            mainInfoLoaded: false
        };
    },
    methods: {
        //退出登录点击事件
        loginoutOnclick() {
            this.$store.commit("loginout");
            this.$router.replace("/login");
        },
        //加载用户数据
        loadUserInfo() {
            const fullLoading = this.$loading({
                lock: true,
                text: "数据加载中.....",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });

            Axios.all([
                UserInfoService.getUserInfo(),
                //SystemService.getMenuList(),
                UserInfoService.getMenuListByAccountPermission()
            ])
                .then(
                    Axios.spread((userRes, menuRes, permissionRes) => {
                        this.mainInfoLoaded = true;
                        this.$store.commit("updateUserInfo", userRes.data);
                        this.username = userRes.data.LoginName;
                        this.enumList = menuRes.data;
                        //this.$store.commit("setUserPermission", permissionRes.data);
                    })
                )
                .finally(() => {
                    fullLoading.close();
                });
        },
        //修改密码点击事件
        editPwdOnclick() {
            this.editPwdObj.visible = true;
            this.editPwdObj.dataForm.oldPwdStr = "";
            this.editPwdObj.dataForm.newPwdStr = "";
            this.editPwdObj.dataForm.cNewPwdStr = "";
        },
        //修改密码提交点击事件
        editPwdSubmitOnclick() {
            let oPwd = this.editPwdObj.dataForm.oldPwdStr;
            let nPwd = this.editPwdObj.dataForm.newPwdStr;
            let cPwd = this.editPwdObj.dataForm.cNewPwdStr;
            if (typeof oPwd === "undefined" || !oPwd) {
                this.$message.error("请输入旧密码");
                return;
            }
            if (typeof nPwd === "undefined" || !nPwd) {
                this.$message.error("请输入新密码");
                return;
            }
            if (typeof cPwd === "undefined" || !cPwd) {
                this.$message.error("请输入确认新密码");
                return;
            }
            if (nPwd !== cPwd) {
                this.$message.error("新密码和确认新密码不一致");
                return;
            }
            this.editPwdObj.loading = true;
            UserInfoService.editPassword(oPwd, cPwd)
                .then(res => {
                    this.editPwdObj.visible = false;
                    this.$message.success("修改密码成功");
                    this.loginoutOnclick();
                })
                .finally(() => {
                    this.editPwdObj.loading = false;
                });
        },
        //图标点击事件
        logoOnClick() {
            // this.$router.push("/mainpage/index");
            return;
        },
        toContestantIndex() {
            this.$router.replace("/contestant");
        }
    },
    created() {
        this.loadUserInfo();
        this.activeRoute = this.$route.path;
    },
    watch: {
        $route(to, from) {
            this.$refs["mainpage-left-menu"].activeIndex = this.$route.path;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "./../../element-variables.scss";

.layout-header {
    background-color: $--color-primary;
    color: white;
    box-shadow: rgba(0, 0, 0, 0.15) 0 3px 13px;

    .header-logo {
        // padding-top: 3px;

        // cursor:pointer;
        i {
            font-size: 3.2rem;
            display: inline-block;
            vertical-align: middle;
        }

        h1 {
            color: white;
            display: inline-block;
            vertical-align: middle;
            font-size: 1.6rem;
            font-weight: 400;
            margin-left: 0.2%;
        }
    }
}

.avatar-div {
    text-align: right;
    margin: 10px 10px 10px 0;

    .content-div {
        white-space: nowrap;

        >img {
            width: 40px;
            display: inline-block;
            padding-right: 8px;
        }

        >p {
            display: inline-block;
            vertical-align: middle;
            padding-left: 2.5%;
            font-size: 1rem;
            color: white;
        }
    }

    &:hover {
        cursor: pointer;
    }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
}

.aside-scrollbar {
    overflow-x: hidden;
    box-shadow: rgba(0, 0, 0, 0.05) 4px 0px 10px;
}

.main-scrollbar {
    width: 100%;
    overflow-x: hidden;
}

.el-scrollbar__wrap {
    overflow-x: hidden !important;
}

.menu-collapse {
    text-align: center;
    vertical-align: middle;

    button {
        color: $--color-primary;
        border: none;
        outline: none;
        display: inline-block;
        margin: 5px 0;

        i {
            font-size: 1.5rem;
            font-weight: 100;
        }
    }
}

.el-menu-item.is-active {
    background-color: rgba(0, 0, 0, 0.02) !important;
    border-left: 3px solid #409eff;
    // color: #303133;
}

.ele-transform-180deg {
    transform: rotateZ(180deg);
}


//菜单关闭
.el-submenu>.el-submenu__title .el-submenu__icon-arrow {
    -webkit-transform: rotateZ(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotateZ(-90deg);
}

//菜单展开
.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
    -webkit-transform: rotateZ(0deg);
    -ms-transform: rotate(0deg);
    transform: rotateZ(0deg);
}
</style>
